import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './sidebar.component';
import { SidebarInitialComponent } from './sidebar-initial/sidebar-initial.component';
import { SidebarSecondComponent } from './sidebar-second/sidebar-second.component';
import { SharedModule } from '../../shared.module';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    SidebarComponent,
    SidebarInitialComponent,
    SidebarSecondComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule
  ],
  exports: [
    SidebarComponent
  ]
})
export class SidebarModule { }
